import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type DeleteCustomSurfaceTreatmentResponse = ClientInferResponseBody<
  typeof contract.companySettings.deleteCustomSurfaceTreatment,
  200
>;

export const deleteCustomSurfaceTreatmentApi = async ({
  companyId,
  surfaceTreatmentId,
}: {
  companyId: string;
  surfaceTreatmentId: string;
}): Promise<DeleteCustomSurfaceTreatmentResponse> => {
  const response = await api.companySettings.deleteCustomSurfaceTreatment.mutation({
    params: { id: companyId, surfaceTreatmentId },
    body: {},
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to delete custom surface treatment", response.status, response.body);
};
